module.exports = __webpack_public_path__ + "media/images/mission_icon_3-64b97e60f4442785df2228abc9f539f5.svg";